import React, { useState } from 'react';
import { Col, Form, Row, Button } from 'react-bootstrap';
import { useAdvanceTableContext } from 'providers/AdvanceTableProvider';
import IconButton from 'components/common/IconButton';
// import { Link } from 'react-router-dom';
// import paths from 'routes/paths';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import PropTypes from 'prop-types';
import { deleteCustomerMulti } from 'nursd-dashboard/api/customerTable';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import paths from 'routes/paths';

// eslint-disable-next-line react/prop-types
const CustomersTableHeader = ({
  customers,
  // setCustomers,
  getCustomer,
  handleDownload
}) => {
  const { getSelectedRowModel } = useAdvanceTableContext();

  const { authToken } = useAuth();
  const [actionType, setActionType] = useState('');

  const deleteMultipleRecord = async array => {
    await deleteCustomerMulti(authToken, array)
      .then(() => {
        setActionType('');
        toast.success(`Records deleted successfully.`, {
          theme: 'colored'
        });
        getCustomer();
      })
      .catch(e => console.log(e));
  };

  return (
    <>
      <Row className="flex-between-center mb-2">
        <Col sm={6} lg={4} className="p-1">
          <AdvanceTableSearchBox />
        </Col>
      </Row>
      <Row className="flex-between-center">
        <Col>
          <h5 className="mb-0 text-secondary">
            Patient Records : {customers?.length}
          </h5>
        </Col>
        <Col xs={8} sm="auto" className="ms-auto text-end ps-0">
          {getSelectedRowModel().rows.length > 0 ? (
            <div className="d-flex">
              <Form.Select
                size="sm"
                aria-label="Bulk actions"
                onChange={e => setActionType(e.target.value)}
                value={actionType}
              >
                <option>Bulk Actions</option>
                <option value="delete">Delete</option>
              </Form.Select>
              {actionType !== '' && (
                <Button
                  type="button"
                  variant="falcon-default"
                  size="sm"
                  className="ms-2"
                  onClick={() => {
                    if (actionType === 'delete') {
                      deleteMultipleRecord(
                        getSelectedRowModel().rows?.map(
                          i => i?.original?.original?.id
                        )
                      );
                    }
                  }}
                >
                  Apply
                </Button>
              )}
            </div>
          ) : (
            <div id="orders-actions">
              <Col xs="auto" className="d-flex order-md-0">
                <Link to={paths.nursd_customer_upload}>
                  <IconButton
                    variant="success"
                    iconClassName="me-2"
                    icon="plus"
                    size="sm"
                  >
                    <span className="text-light ms-1">Upload CSV</span>
                  </IconButton>
                </Link>
                <Link to={paths.nursd_customer_form}>
                  <IconButton
                    variant="falcon-default"
                    size="sm"
                    icon="plus"
                    transform="shrink-3"
                    className="mx-2"
                  >
                    <span className="d-none text-dark d-sm-inline-block ms-1">
                      New
                    </span>
                  </IconButton>
                </Link>
                <IconButton
                  variant="falcon-default"
                  size="sm"
                  icon="external-link-alt"
                  transform="shrink-3"
                  onClick={() => handleDownload()}
                >
                  <span className="d-none d-sm-inline-block ms-1">Export</span>
                </IconButton>
              </Col>
              {/* <IconButton
              variant="falcon-default"
              size="sm"
              icon="filter"
              transform="shrink-3"
              className="mx-2"
            >
              <span className="d-none d-sm-inline-block ms-1">Filter</span>
            </IconButton> */}
            </div>
          )}
        </Col>
      </Row>
    </>
  );
};

CustomersTableHeader.propTypes = {
  customers: PropTypes.any,
  setCustomers: PropTypes.any,
  getCustomer: PropTypes.any,
  handleDownload: PropTypes.any
};

export default CustomersTableHeader;
